const generateKey = (productDivergenceId, batchId) => {
  return `product_divergence:${productDivergenceId}-${batchId}`
}

const get = (productDivergenceId, batchId) => {
  const key = generateKey(productDivergenceId, batchId)

  const savedBatches = localStorage.getItem(key)

  return (savedBatches && JSON.parse(savedBatches)) || []
}

const set = (productDivergenceId, batchId, newBatches) => {
  const key = generateKey(productDivergenceId, batchId)

  localStorage.setItem(key, JSON.stringify(newBatches))
}

const remove = (productDivergenceId, batchId) => {
  const key = generateKey(productDivergenceId, batchId)

  localStorage.removeItem(key)
}

export const productDivergenceBatchStore = {
  get,
  set,
  remove
}
